module.exports = __webpack_public_path__ + "static/media/Stirrer_Pic4_WhiteBG.0ee715a9.png";